// extracted by mini-css-extract-plugin
module.exports = {"frame":"Scrollable-module__frame___1073y","content":"Scrollable-module__content___1oiDv","end":"Scrollable-module__end___19Ab8"};